import {
  LOAD_SUCCESS_TYPES_EMAILS,
  LOAD_FAIL_TYPES_EMAILS,
  SAVE_SUCCESS_TYPES_EMAILS,
  SAVE_FAIL_TYPES_EMAILS,
  UPDATE_SUCCESS_TYPES_EMAILS,
  UPDATE_FAIL_TYPES_EMAILS,
  DELETE_SUCCESS_TYPES_EMAILS,
  DELETE_FAIL_TYPES_EMAILS,
} from "../actions/typeEmailAction";

const initialState = {
  loaded: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS_TYPES_EMAILS:
      return {
        ...state,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case LOAD_FAIL_TYPES_EMAILS:
      return {
        ...state,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SAVE_SUCCESS_TYPES_EMAILS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: [...state.data, action.payload],
        error: null,
      };
    case SAVE_FAIL_TYPES_EMAILS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case UPDATE_SUCCESS_TYPES_EMAILS:
      const updatedListe = [];

      state.data.forEach((item) => {
        if (item.type_lot_id === action.payload.type_email_id) {
          item = action.payload;
        }
        updatedListe.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListe,
        error: null,
      };
    case UPDATE_FAIL_TYPES_EMAILS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case DELETE_SUCCESS_TYPES_EMAILS:
      const filtered = state.data.filter((item) => {
        return item.type_lot_id !== action.id;
      });
      return {
        ...state,
        loading: false,
        loaded: true,
        data: filtered,
        error: null,
      };
    case DELETE_FAIL_TYPES_EMAILS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    default:
      return state;
  }
}
